import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import Container from '../partials/Container'
import PostEditor from '../partials/PostEditor'

import styleB from '../style'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Auth', 'User', 'Blog', 'Config')
@observer
export class EditPost extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        active: true,
        pending: true,
        title: '',
        content: ''
      }
    }
  }

  componentWillMount () {
    const _findPost = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending || this.props.User.me.pending) {
          return _findPost()
        }

        this.props.Blog.searchPost(this.props.match.params.seo).then(post => {
          this.setState({
            ...this.state,
            editor: {
              ...this.state.editor,
              pending: false,
              title: post.title,
              content: post.content
            }
          })
        })
      }, 100)
    }

    _findPost()
  }

  onSaveClick (e) {
    e.preventDefault()

    const post = {
      title: this.state.editor.title,
      content: this.state.editor.content
    }

    const _post = this.props.Blog.posts
      .slice()
      .find(p => p.seo === this.props.match.params.seo)

    Promise.all([
      this.props.Blog.patchPost(_post.id, 'title', post.title),
      this.props.Blog.patchPost(_post.id, 'content', post.content)
    ]).then(() => {
      return this.props.history.push(
        `/dashboard/news/${this.props.match.params.seo}`
      )
    })
  }

  onTitleChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        title: e.target.value
      }
    })
  }

  onContentChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        content: e
      }
    })
  }

  onInputFocus (type, e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        active: true,
        field: type
      }
    })
  }

  onInputBlur (type, e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        active: false,
        field: null
      }
    })
  }

  render () {
    if (this.state.editor.pending) {
      return null
    }

    return (
      <Container {...this.props}>
        <Row>
          <Col>
            <Row>
              <Col>
                <h2 className={css(styleB.headers.h2)}>Edit Post</h2>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col />
              <Col>
                <span
                  onClick={this.onSaveClick.bind(this)}
                  className={css(styleB.buttons.button, styleB.buttons.red)}
                >
                  Save
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <PostEditor
              onTitleChange={this.onTitleChange.bind(this)}
              onContentChange={this.onContentChange.bind(this)}
              onContentFocus={this.onInputFocus.bind(this, 'content')}
              onContentBlur={this.onInputBlur.bind(this, 'content')}
              editor={this.state.editor}
              theme={THEME_LIST[this.props.Config.theme]}
            />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default EditPost



// WEBPACK FOOTER //
// ./src/components/News/Edit/index.js